import config from '@/config';

export const resolveRecommendedArtworkImageUrl = (artwork) => {
  const image = artwork?.artwork_media?.artwork_main_picture;
  const rawValue =
    typeof image === 'string'
      ? image
      : image?.image_id || image?.imageId || image?.image || image?.url || image?.image_url || null;

  if (!rawValue || typeof rawValue !== 'string') {
    return null;
  }

  const trimmed = rawValue.trim();
  if (!trimmed) {
    return null;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `${config.app.imageServiceDomain}/${encodeURI(trimmed)}/w=480`;
};

export const getRecommendedArtworkTitle = (artwork) =>
  artwork?.artwork_about?.artwork_title?.trim() || 'Untitled';

export const getRecommendedArtworkArtistName = (artwork) =>
  [
    artwork?.artwork_about?.artwork_artist_name,
    artwork?.artwork_about?.artwork_artist?.user_name,
    artwork?.artwork_about?.artwork_artist?.user_artist_name,
    artwork?.artwork_about?.artwork_artist?.artist_name,
    artwork?.artwork_about?.artwork_gallery_artist?.artist_name,
  ].find((value) => typeof value === 'string' && value.trim().length > 0)?.trim() || 'Artist';

export const getRecommendedArtworkPricingAmount = (artwork) =>
  artwork?.artwork_about?.artwork_is_auction
    ? artwork?.artwork_auction?.current_bid_price
    : artwork?.artwork_about?.artwork_price;

export const formatRecommendedArtworkPrice = (amount, currency) => {
  const numericAmount =
    typeof amount === 'number' ? amount : typeof amount === 'string' ? Number(amount) : NaN;
  const normalizedCurrency = typeof currency === 'string' ? currency.trim().toUpperCase() : '';

  if (!Number.isFinite(numericAmount)) {
    return null;
  }

  if (!normalizedCurrency) {
    return `${numericAmount}`;
  }

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: normalizedCurrency,
      maximumFractionDigits: 0,
    }).format(numericAmount);
  } catch (_error) {
    return `${numericAmount} ${normalizedCurrency}`;
  }
};
